import {AbstractControl, ValidationErrors} from '@angular/forms';

/**
 * The default name of a new shape: its kind and a number, "Polygon 4".
 *
 * Each kind counts on its own -- the third line drawn is "Polyline 3", not
 * "Polyline 7" because four polygons came first -- and a number already in
 * use is never handed out again: after deleting "Polygon 1" of two, the next
 * is "Polygon 3", not a second "Polygon 2". So the number is one past the
 * larger of how many of that kind there are and the highest number a name
 * of that kind already carries.
 *
 * `label` is the kind's name in the user's language; `names` are the names
 * of the existing shapes of that kind.
 */
export function nextDefaultName(label: string, names: Array<string | null | undefined>): string {
  const pattern = new RegExp(`^${escapeRegExp(label.trim())}\\s+(\\d{1,9})$`, 'i');
  let highest = 0;
  for (const name of names) {
    const match = pattern.exec((name || '').trim());
    if (match) {
      highest = Math.max(highest, Number(match[1]));
    }
  }
  return `${label} ${Math.max(highest, names.length) + 1}`;
}

function escapeRegExp(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * A name field that may not be left empty, nor only spaces: shapes, spots
 * and projects always have a name (SyncService.hasName is the same rule).
 */
export function requiredName(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  return typeof value === 'string' && value.trim() !== '' ? null : {nameRequired: true};
}
